module.exports = __webpack_public_path__ + "media/site/images/claim-6589c95594bb787ff06a0c7690705df7.png";